import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { TooltipModule } from 'primeng/tooltip';

import { type TfSegmentedControlOption } from '@tourfold/libraries/shared-ui';

import { RoleGrantsPopoverComponent } from './role-grants-popover';
import {
  PermissionGroupDefinition,
  PermissionLevel,
  grantsForGroupLevel,
} from './role-permission-groups';

@Component({
  selector: 'tf-settings-role-permission-level-selector',
  imports: [RoleGrantsPopoverComponent, TooltipModule],
  templateUrl: './role-permission-level-selector.html',
  styleUrl: './role-permission-level-selector.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RolePermissionLevelSelectorComponent {
  readonly group = input.required<PermissionGroupDefinition>();
  readonly options = input.required<readonly TfSegmentedControlOption[]>();
  readonly value = input.required<string>();
  readonly ariaLabel = input.required<string>();
  readonly disabled = input(false);

  readonly valueChange = output<string>();

  selectOption(option: TfSegmentedControlOption): void {
    if (this.disabled() || option.disabled || option.value === this.value()) {
      return;
    }
    this.valueChange.emit(option.value);
  }

  optionLevel(option: TfSegmentedControlOption): PermissionLevel {
    return parsePermissionLevel(option.value) ?? 'none';
  }

  optionGrants(option: TfSegmentedControlOption): readonly string[] {
    return grantsForGroupLevel(this.group(), this.optionLevel(option));
  }

  shouldShowGrantPopover(option: TfSegmentedControlOption): boolean {
    const level = parsePermissionLevel(option.value);
    return !!level && level !== 'none' && this.group().levels.includes(level);
  }
}

function parsePermissionLevel(value: string): PermissionLevel | null {
  if (value === 'none' || value === 'read' || value === 'write' || value === 'manage') {
    return value;
  }
  return null;
}
